import React from 'react';
import PropTypes from 'prop-types';

import ComponentSwitch from './ComponentSwitch';

class RegionsRenderer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const { data } = this.props;
    if (nextProps.data === data) {
      return false;
    }
    return true;
  }

  render() {
    const { data, regions } = this.props;
    if (data) {
      return data.map(function (region, i) {
        if (regions.includes('All') || regions.includes(region.id)) {
          if (region.fragments.length > 0) {
            return <ComponentSwitch components={region.fragments} key={`cr${i}`} />;
          }
          // Allow sub region embedded as needed for include pages
          return <RegionsRenderer data={region.regions} regions={['All']} key={`rr${i}`} />;
        }
      });
    }
    return null;
  }
}
export default RegionsRenderer;

RegionsRenderer.propTypes = {
  data: PropTypes.array,
  regions: PropTypes.array,
};
